import { useEffect, useState } from "react";
import { BiCopy, BiData, BiUserPlus } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import { BsFire, BsGear } from "react-icons/bs";
import DbSettingsModal from "./Settings/DbSettingsModal";
import LoadingDB from "./LoadingDb";
import SmallAlert from "../../PlatformComponents/SmalAlert";
import LogsMain from "./Logs/LogsMain";
import MainSqlData from "./SQLData/MainSQLData";
import MainUsers from "./Users/MainUsers";
import { TbArrowsRightLeft } from "react-icons/tb";
import MigrationMain from "./Migration/MigrationMain";
import FirewallMain from "./Firewall/FirewallMain";

const OpenSQLDb = () => {
    const user_id = sessionStorage.getItem("user_id");
    const { project_id, db_id, link_db } = useParams()
    const navigate = useNavigate()
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [openBackup, setOpenBackup] = useState(false)
    const [settings, setSettings] = useState({})
    const [dbName, setDbName] = useState(false)
    const [dbId, setDbId] = useState(false)
    const [copied, setCopied] = useState(false)
    const [copiedHost, setCopiedHost] = useState(false)
    const [instanceData, setInstanceData] = useState({})
    const [schema, setSchema] = useState("")
    const [schemas, setSchemas] = useState([]);

    const changePage = (page) => {
        navigate(`/project_panel/${project_id}/databases/${db_id}/${page}`)
    }

    const goBack = () => {
        navigate(`/project_panel/${project_id}/databases`)
    }

    useEffect(() => {
        if (user_id) {
            fetchRecords();
        } else {
            setError(true);
            setLoading(false);
        }
    }, []);


    const fetchRecords = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_specific_db", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id, db_id }),
            });
            if (response.ok) {
                const result = await response.json();
                let accessData = result.databases || {};
                let schemasList = result.schemas || [];

                setDbName(accessData.db_name);
                setDbId(accessData._id);
                setInstanceData(accessData.instance);
                setSchemas(schemasList); 
                if (schemasList.length > 0) setSchema(schemasList[0]); 

                let filteredData = [];
                filteredData.push(accessData);
                const recordsArray = Object.values(filteredData);
                const settings = recordsArray[0]["settings"];
                setSettings(settings);
                setRecords(recordsArray);

            } else {
                setError(true);
            }
            setLoading(false)
        } catch (err) {
            setLoading(false)
            setError(true);
        } finally {
            setTimeout(() => {
                setLoading(false)
            }, 1000);
        }
    };

    const handleCopyClick = () => {
        navigator.clipboard.writeText(dbId);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleCopyClickHost = (host) => {
        navigator.clipboard.writeText(host);
        setCopiedHost(true);
        setTimeout(() => setCopiedHost(false), 2000);
    };

    return (
        <div>
            <div className="new_section_main_view">
                <p className="new_section_main_view_title">
                    <i className="fa-solid fa-chevron-left" onClick={goBack}></i> <span className={`${dbName ? "new_section_main_view_title_span" : "new_section_main_view_title_span_loading"}`}>{dbName}</span>
                    <span className={`${dbId ? "new_section_main_view_title_db_id" : "new_section_main_view_title_db_id_loading"}`}>
                        {dbId}
                        {dbId && (
                            <i onClick={handleCopyClick}>
                                {copied ? (
                                    <i className="fa-solid fa-check"></i>
                                ) : (
                                    <BiCopy />
                                )}
                            </i>
                        )}
                    </span>
                </p>
                <p className="new_section_main_view_subtitle">
                    {instanceData.sql_type == "sqlserver" ? (
                         <>
                            Instance host <strong>{instanceData.cloud_fqdn}</strong>
                        </>
                    ):(
 <>
                            Instance host <strong>{instanceData.erioon_fqdn}</strong>
                        </>
                    )}

                    {/* {instanceData.sql_type == "postgressql" ? (
                        <>
                            <span className={`${dbId ? "new_section_main_view_title_db_id" : "new_section_main_view_title_db_id_loading"}`}>
                                {instanceData.erioon_fqdn}
                                {instanceData.erioon_fqdn && (
                                    <i onClick={() => handleCopyClickHost(instanceData.erioon_fqdn)}>
                                        {copiedHost ? (
                                            <i className="fa-solid fa-check"></i>
                                        ) : (
                                            <BiCopy />
                                        )}
                                    </i>
                                )}
                            </span>
                        </>
                    ) : (
                        <>
                        <span className={`${dbId ? "new_section_main_view_title_db_id" : "new_section_main_view_title_db_id_loading"}`}>
                                {instanceData.cloud_fqdn}
                                {instanceData.cloud_fqdn && (
                                    <i onClick={() => handleCopyClickHost(instanceData.cloud_fqdn)}>
                                        {copiedHost ? (
                                            <i className="fa-solid fa-check"></i>
                                        ) : (
                                            <BiCopy />
                                        )}
                                    </i>
                                )}
                            </span>
                        </>
                    )} */}

                </p>
                {!loading && (
                    <>
                        <SmallAlert message={"Backup for this database is disabled"} status={!settings.backup} functionToDo={setOpenBackup} />
                        <SmallAlert message={"Autoscale for this database is disabled"} status={!settings.autoscale} functionToDo={setOpenBackup} />
                    </>
                )}

                <div className="open_db_main_view">
                    <div className="open_db_main_navbar">
                        <div className="open_db_main_navbar_cont">
                            <button className={`open_db_main_btn ${link_db === "data" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("data")}><BiData /> Data</button>
                            <button className={`open_db_main_btn ${link_db === "users" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("users")}><BiUserPlus /> Users</button>
                            <button className={`open_db_main_btn ${link_db === "firewall" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("firewall")}><BsFire /> Firewall</button>
                            {/* <button className={`open_db_main_btn ${link_db === "migration" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("migration")}><TbArrowsRightLeft /> Migration</button> */}
                            {/* <button className={`open_db_main_btn ${link_db === "logs" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("logs")}><TbLogs /> Logs</button> */}
                            {/* {loadingSync ? (
                                <div className="open_db_main_btn_loading"></div>
                            ) : (
                                <>
                                    {syncStatus ? (
                                        <button className="open_db_main_btn" onClick={() => setOpenBackupModal(true)}><BsCloudCheck /> Backup</button>
                                    ) : (
                                        <button className="open_db_main_btn open_db_main_btn_to_sync" onClick={() => setOpenBackupModal(true)}><MdOutlineBackup /> Backup</button>
                                    )}
                                </>
                            )} */}

                            {/* <button className={`open_db_main_btn ${link_db === "encryption" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("encryption")}><MdOutlineEnhancedEncryption /> Encryption</button> */}
                            {/* <button className={`open_db_main_btn ${link_db === "migration" ? "open_db_main_btn_selected" : ""}`} onClick={() => changePage("migrations")}><BiTransfer /> Migration</button> */}
                        </div>
                        <div className="open_db_main_navbar_cont">
                            <button className="open_db_main_btn" onClick={() => setOpenBackup(true)}><BsGear /> Settings</button>
                        </div>
                    </div>
                    {loading ? (
                        <LoadingDB />
                    ) : (
                        <>
                            {link_db === "data" ? (
                                <MainSqlData fetchRecords={fetchRecords} records={records} schema={schema} schemas={schemas} setSchema={setSchema} instanceData={instanceData}/>
                            ) : link_db === "users" ? (
                                <MainUsers fetchRecords={fetchRecords} records={records} dbName={dbName} />
                            ) : link_db === "migration" ? (
                                <MigrationMain fetchRecords={fetchRecords} records={records} dbName={dbName} />
                            ) : link_db === "firewall" ? (
                                <FirewallMain instanceData={instanceData} fetchRecords={fetchRecords} records={records} dbName={dbName} />
                            ) : (
                                <></>
                            )}
                        </>
                    )}

                </div>
            </div>
            <DbSettingsModal
                show={openBackup}
                handleClose={() => setOpenBackup(false)}
                settings={settings}
                fetchRecords={fetchRecords}
            />
        </div>
    )
}

export default OpenSQLDb